export { default } from './DisplayImage'
